/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: HomeOffice = 1, MainOffice = 2, Billing = 3, Warehouse = 4, ServiceArea = 5, BranchOffice = 6
 */
export enum Routemize_Constants_BaseLocation {
    HOME_OFFICE = 'HomeOffice',
    MAIN_OFFICE = 'MainOffice',
    BILLING = 'Billing',
    WAREHOUSE = 'Warehouse',
    SERVICE_AREA = 'ServiceArea',
    BRANCH_OFFICE = 'BranchOffice',
}
